import { Dimensions } from 'react-native';

import { isTablet } from 'utils/responsiveness';

export const { width: windowWidth, height: windowHeight } =
    Dimensions.get('window');
// Mock epg configuration(sizes).
export const channelsCount = 10; // count of the mocked generated channels.
export const timeLineDaysCount = 11; // how many days should be displayed in the epg X axis.
export const channelsPerPage = 12;
export const gridRowHeight = 50; // the height for the each channel row/program item.
export const rowStickyHeaderWidth = 100; // width of the channel logo and "like" icon block.
export const extraIndentX = 4; // right indent to dont stop at the right border and see more a bit when scrolling by X.
export const oneHourWidth = isTablet
    ? (windowWidth - rowStickyHeaderWidth) / 2
    : windowWidth - rowStickyHeaderWidth;
export const dpPerMinute = oneHourWidth / 60;
export const dpPerHour = dpPerMinute * 60;
export const dpPerDay = dpPerHour * 24;

export const epgWidth = windowWidth - rowStickyHeaderWidth;
export const timeLineUpdateInterval = (1 / oneHourWidth) * 60 * 60 * 1000;
export const STATIC_LIVE_PROGRAM_ID = 'STATIC_LIVE_PROGRAM_ID';

export enum ArrowDirection {
    LEFT = 'left',
    RIGHT = 'right',
}
